<template>
  <div class="content">
    <div class="btn-container u-pull-right">
      <back-button></back-button>
    </div>
    <h2 class="font-light">
      Training File: {{ getCandidateName() }}
    </h2>
    <server-error v-bind:error="error.serverError"></server-error>
    <space></space>
    <button
      v-if="permissions.includes('records.add_record')"
      class="btn-info btn-small outline u-pull-right"
      v-on:click="addRecord"
    >
      <span class="icon">
        <i
          class="fa-wrapper fa fa-plus-circle"
          aria-hidden="true"
          ></i>
      </span>
      Add Record
    </button>
    <h5 class="font-alt font-light">Training Records</h5>
    <record-table v-bind:records="file"></record-table>
    <space></space>
    <button
      v-if="permissions.includes('records.add_record')"
      class="btn-info btn-small outline u-pull-right"
      v-on:click="addScannedRecord"
    >
      <span class="icon">
        <i
          class="fa-wrapper fa fa-plus-circle"
          aria-hidden="true"
          ></i>
      </span>
      Add Scanned Record
    </button>
    <h5 class="font-alt font-light">Scanned Records</h5>
    <scanned-record-table v-bind:scannedRecordList="scannedRecords">
    </scanned-record-table>
    <space></space>
    <button
      v-if="permissions.includes('records.add_record')"
      class="btn-info btn-small outline u-pull-right"
      v-on:click="addExam"
    >
      <span class="icon">
        <i
          class="fa-wrapper fa fa-plus-circle"
          aria-hidden="true"
          ></i>
      </span>
      Add Exam
    </button>
    <h5 class="font-alt font-light">Exams</h5>
    <exam-table v-bind:examList="examList"></exam-table>
  </div>
</template>
<script>
import RecordTable from "@/components/records/RecordTable";
import ScannedRecordTable from "@/components/records/ScannedRecordTable";
import ExamTable from "@/components/exams/ExamTable";
import BackButton from "@/components/BackButton";
import { DateFormatter } from "@/functions/dateFormat.function";
import { mapGetters } from "vuex";
import ServerError from "@/components/ServerError";

export default {
  name: "record-user-file",
  components: {
    ServerError,
    RecordTable,
    ScannedRecordTable,
    BackButton,
    ExamTable
  },
  computed: {
    ...mapGetters("records", ["file", "scannedRecordList"]),
    ...mapGetters("exams", ["examList"]),
    ...mapGetters("core", ["error"]),
    ...mapGetters("auth", ["users", "permissions"]),

    scannedRecords: function() {
      return this.scannedRecordList.filter(
        x => x.candidate.id == this.$route.params.id
      );
    }
  },
  methods: {
    formatDate: function(dateString) {
      return DateFormatter(dateString);
    },
    getCandidateName: function() {
      if (this.file[0] && this.file[0].candidate) {
        return this.file[0].candidate.full_name
      } else {
        return this.users.find(u => u.id == this.$route.params.id).full_name;
      }
    },
    addRecord: function() {
      this.$router.push({
        name: "record-create",
        query: { candidate: this.$route.params.id }
      });
    },
    addScannedRecord: function() {
      this.$router.push({
        name: "scanned-record-create",
        query: { candidate: this.$route.params.id }
      });
    },
    addExam: function() {
      this.$router.push({
        name: "exam-create",
        query: { candidate: this.$route.params.id },
      });
    },
  },
  mounted() {
    this.$store.dispatch("records/getFile", { id: this.$route.params.id });
    this.$store.dispatch(
      "exams/getExamList", { candidate: this.$route.params.id }
    );
    this.$store.dispatch("records/listScannedRecord");
  }
};
</script>
